import { useAuth } from '../../contexts/AuthContext';
import {
  isAdminUser,
  userCanAccessCommunity,
  userCanAccessLessons,
} from '../../utils/enrollmentAccess';

export interface EnrollmentAccess {
  canAccessCommunity: boolean;
  canAccessLessons: boolean;
  isAdmin: boolean;
}

export function useEnrollmentAccess(courseId: string): EnrollmentAccess {
  const { user } = useAuth();

  return {
    canAccessCommunity: userCanAccessCommunity(user, courseId),
    canAccessLessons: userCanAccessLessons(user, courseId),
    isAdmin: isAdminUser(user),
  };
}
